import ErrorIcon from '@mui/icons-material/ErrorOutline';
import Link from 'next/link';
import React from 'react';
import styles from './LocationErrorMessage.module.scss';
const LocationErrorMessage: React.FC = () => {
  const urgentCareCentersLink = process.env.NEXT_PUBLIC_WELLNOW_URGENT_CARE_CENTERS;
  return <div className={styles['error-container']} data-sentry-component="LocationErrorMessage" data-sentry-source-file="LocationErrorMessage.tsx">
			<ErrorIcon className={styles['error-icon']} data-sentry-element="ErrorIcon" data-sentry-source-file="LocationErrorMessage.tsx" />
			<div className={styles['error-content']}>
				<span className={styles['error-text']}>
					We couldn&apos;t find the location you&apos;re looking for.{' '}
				</span>
				{urgentCareCentersLink && <Link href={urgentCareCentersLink || '#'} className={styles['error-link']} target="_blank" rel="noopener noreferrer">
						Please select a valid location
					</Link>}
			</div>
		</div>;
};
export default LocationErrorMessage;